import { GlossaryText } from '../../ui'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

export function MetricStrip() {
  const { metricItems } = useW5Live()
  return (
    <div data-scope="metric-strip">
      <div className={styles.metricStrip}>
        {metricItems.map((item) => (
          <div className={styles.metric} key={item.key}>
            <p className={styles.metricLabel}><GlossaryText text={item.label} /></p>
            <p className={styles.metricValue}>{item.value}</p>
            <p className={styles.metricDelta}>
              <span className={item.good ? styles.deltaGood : styles.deltaBad}>
                {item.deltaDir === 'up' ? '↑' : '↓'} {item.delta.replace(/^[+−-]/, '')}
              </span>{' '}
              较上期
            </p>
            <p className={styles.metricStatus}>
              <i className={`${styles.dot} ${styles[item.status]}`} />
              <GlossaryText text={item.note} />
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
